import { useMutation } from '@tanstack/react-query';
import { useWoody } from '../../woody/woody.js';
import { useInvalidateQueryExportRequests } from '../queries/useInvalidateQueryExportRequests.js';
import { useContextAccessToken } from '../../permission/contexts/AnonShareTokenContext.js';
import { appRoutes } from '../../app/routing/routes.config.js';
import { generatePath } from '@fabric-app/utils/url/routing';
import { openExternal } from '@fabric-app/ui/components/Link/LinkExternal';

const useMutationExportResources = (mutationKey) => {
  const { client } = useWoody();
  const invalidateQueryExportRequests = useInvalidateQueryExportRequests();
  const accessToken = useContextAccessToken();
  const mutation = useMutation({
    mutationKey: [
      "export-resources",
      mutationKey
    ],
    mutationFn: async (vars) => {
      return client.v2("/v2/export", {
        method: "post",
        body: {
          resourceIds: vars.resourceIds || []
        },
        query: {
          accessToken
        }
      });
    },
    onSettled: invalidateQueryExportRequests,
    onSuccess: (data) => {
      if (accessToken) {
        const url = new URL(generatePath(appRoutes.exportStatus, {
          exportId: data.id
        }), window.location.origin);
        url.searchParams.set("accessToken", accessToken);
        openExternal(url.toString());
      }
    }
  });
  return mutation;
};

export { useMutationExportResources };
//# sourceMappingURL=useMutationExportResources.js.map
